/**
 * Filter options for which acquisition types to sync from FastBound.
 * Stored on Fastbound_Account to control sync behavior.
 */
enum FastBoundAcquisitionTypeFilterEnum {
    ALL = "all",
    MANUFACTURED = "manufactured",
    PURCHASED = "purchased",
    IMPORTED = "imported",
}

export default FastBoundAcquisitionTypeFilterEnum;
